export default "__VITE_ASSET__DP2r5pXB__"